import React from 'react'
import { MenuItem, Position, ButtonProps } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button } from '@ui'
import { ILeaseEventType } from '@api'
import { get } from 'lodash'

interface ITypeItem {
  label: string
  value: ILeaseEventType
}

const items: ITypeItem[] = [
  { label: 'Renewal', value: 'Renewal' },
  { label: 'Sublease', value: 'Sublease' },
  { label: 'Termination', value: 'Termination' },
  { label: 'Other', value: 'Other' },
]

const EventTypeSelect = Select2<ITypeItem>

interface IProps {
  buttonProps?: ButtonProps
  placeholder?: string
  value: ILeaseEventType | string
  onChange: (type: ITypeItem) => void
}

export default function LeaseEventTypeSelect({
  onChange,
  placeholder,
  value,
  buttonProps,
}: IProps) {
  return (
    <EventTypeSelect
      popoverProps={{
        position: Position.BOTTOM,
        minimal: true,
      }}
      filterable={false}
      items={items}
      itemRenderer={(type, { handleClick }) => (
        <MenuItem
          key={type.value}
          active={value ? type.value === value : false}
          onClick={handleClick}
          text={type.label}
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
        text={value ? value : placeholder || 'Select'}
      />
    </EventTypeSelect>
  )
}
